:root {
  font-family: system-ui, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #e2e8f0;
  background: #0f172a;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 浅色页面容器（Overview/CompanyRanking/QuadrantChart）*/
.light-page {
  background: #f8fafc;
  color: #1f2937;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#root {
  width: 100%;
  height: 100vh;
}

body {
  margin: 0;
}

/* Mobile touch improvements */
@media (max-width: 767px) {
  .react-flow__controls {
    display: none;
  }

  .react-flow__minimap {
    display: none;
  }

  /* Better touch scrolling */
  .react-flow__renderer {
    -webkit-overflow-scrolling: touch;
  }
}

/* Smooth transitions for bottom sheet */
@media (prefers-reduced-motion: reduce) {
  * {
    transition-duration: 0.01ms !important;
  }
}

/* 产业链节点 hover 效果 — 用 CSS :hover 替代 useState，避免 hover 时组件重渲染导致闪烁 */
.skill-tree-node {
  /* hover 时通过 CSS scale，不触发 React 重渲染 */
}

.skill-tree-node:hover {
  transform: scale(1.03) !important;
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.4) !important;
}

.skill-tree-node.selected:hover {
  transform: scale(1.03) !important;
  box-shadow: 0 0 0 2px #60a5fa, 0 6px 16px rgba(0, 0, 0, 0.5) !important;
}

/* 滚动提示动画 */
@keyframes bounce {
  0%, 100% { transform: translateY(0); opacity: 0.6; }
  50% { transform: translateY(4px); opacity: 1; }
}

@keyframes pulse {
  0%, 100% { opacity: 0.4; }
  50% { opacity: 0.9; }
}

/* hover 浮卡淡入动画 */
@keyframes hoverCardFadeIn {
  from { opacity: 0; transform: translateX(-50%) translateY(4px); }
  to { opacity: 1; transform: translateX(-50%) translateY(0); }
}
